module.exports = AMap;


//////////////////
// WEBPACK FOOTER
// external "AMap"
// module id = 1
// module chunks = 